import type { RegistrationResponseJSON } from '@simplewebauthn/browser'
import { http } from '../../config/axios'

const postUserPasskeyRegistroFinalizar = (
  credential: RegistrationResponseJSON,
  nomeDispositivo: string
): Promise<void> => {
  return http
    .post('api/user/passkey/registro/finalizar', { credential, nomeDispositivo })
    .then(() => undefined)
    .catch((error) => {
      console.error('Erro postUserPasskeyRegistroFinalizar', error)
      throw Error(error.response?.data)
    })
}

export default postUserPasskeyRegistroFinalizar
